import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import CommentPost from 'flarum/forum/components/CommentPost';
import PostMeta from 'flarum/forum/components/PostMeta';
import PostUser from 'flarum/forum/components/PostUser';
import Button from 'flarum/common/components/Button';
import Link from 'flarum/common/components/Link';
import username from 'flarum/common/helpers/username';
import avatar from 'flarum/common/helpers/avatar';
import userOnline from 'flarum/common/helpers/userOnline';
import listItems from 'flarum/common/helpers/listItems';
import ItemList from 'flarum/common/utils/ItemList';
import dayjs from 'dayjs';
import CustomEmojiModal from '../custom-emojis/CustomEmojiModal';
function formatCustomTime(time) {
  const d = dayjs(time);
  const now = dayjs();
  const diffInSeconds = now.diff(d, 'second');
  const diffInMinutes = now.diff(d, 'minute');
  const diffInHours = now.diff(d, 'hour');
  if (diffInSeconds < 60) {
    return "Escrito hace ".concat(diffInSeconds, " segundos");
  } else if (diffInMinutes < 60) {
    return "Escrito hace ".concat(diffInMinutes, " minutos");
  } else if (diffInHours < 24) {
    const hours = Math.floor(diffInHours);
    const minutes = now.diff(d.add(hours, 'hour'), 'minute');
    return "Escrito hace ".concat(hours, " horas y ").concat(minutes, " minutos");
  } else {
    return "Escrito el d\xEDa ".concat(d.format('D/MM/YYYY'), " a las ").concat(d.format('HH:mm'));
  }
}
export default function extendPostDesign(app) {
  var _flarum$reg, _flarum$reg$get;
  // Sanitizar ReactionConverts para evitar que [null, null, null] provoque alertas espurias en fof-reactions al des-reaccionar
  const sanitizeReactionConverts = () => {
    var _app$forum, _app$forum$attribute, _app$forum$data;
    const rc = (_app$forum = app.forum) == null || (_app$forum$attribute = _app$forum.attribute) == null ? void 0 : _app$forum$attribute.call(_app$forum, 'ReactionConverts');
    if (Array.isArray(rc) && (_app$forum$data = app.forum.data) != null && _app$forum$data.attributes) {
      app.forum.data.attributes.ReactionConverts = rc.map(c => c || false);
    }
  };
  sanitizeReactionConverts();
  extend(app, 'boot', sanitizeReactionConverts);
  const suppressReactionWarning = args => {
    try {
      const json = JSON.stringify(args);
      if (json.includes('fof-reactions.forum.warning') || json.includes('convertida') || json.includes('converted') || json.includes('ReactionConverts')) {
        return true;
      }
    } catch (e) {}
    for (const arg of args) {
      if (!arg) continue;
      const str = String(arg);
      if (str.includes('fof-reactions.forum.warning') || str.includes('convertida') || str.includes('converted')) {
        return true;
      }
    }
    return false;
  };
  const AlertManagerState = (_flarum$reg = flarum.reg) == null || (_flarum$reg$get = _flarum$reg.get) == null ? void 0 : _flarum$reg$get.call(_flarum$reg, 'core', 'common/states/AlertManagerState');
  if (AlertManagerState) {
    override(AlertManagerState.prototype, 'show', function (original) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      if (suppressReactionWarning(args)) {
        return null;
      }
      return original(...args);
    });
  }
  if (app.alerts && app.alerts.show) {
    override(app.alerts, 'show', function (original) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }
      if (suppressReactionWarning(args)) {
        return null;
      }
      return original(...args);
    });
  }
  extend(PostMeta.prototype, 'viewItems', function (items) {
    const post = this.attrs.post;
    if (!post || typeof post.createdAt !== 'function') return;
    const time = post.createdAt();
    const formatted = formatCustomTime(time);
    if (items.has('time')) {
      const permalink = typeof this.getPermalink === 'function' ? this.getPermalink(post) : null;
      items.replace('time', m(permalink ? 'a' : 'span', {
        className: permalink ? 'Dropdown-toggle' : '',
        onclick: permalink ? e => this.selectPermalink(e) : undefined,
        'data-toggle': permalink ? 'dropdown' : undefined
      }, formatted), 100);
    }
  });

  // Override PostUser view to have total control over the structure (Avatar vs Data Column)
  override(PostUser.prototype, 'view', function (original) {
    const post = this.attrs.post;

    // If this post is not a regular discussion post (e.g. it is a DialogMessage in flarum/messages),
    // fallback to original Flarum view to prevent breaking messages or third-party posts.
    if (!post || typeof post.discussion !== 'function') {
      return original ? original.call(this) : null;
    }
    const user = post.user();
    return m("header", {
      className: "PostUser"
    }, m("div", {
      className: "PostUser-avatar"
    }, user ? m(Link, {
      href: app.route.user(user)
    }, avatar(user)) : avatar(user)), m("div", {
      className: "PostUser-content"
    }, m("ul", {
      className: "PostUser-list"
    }, m("li", {
      className: "item-username"
    }, m("h3", {
      className: "PostUser-name"
    }, user && this.attrs.link !== false ? m(Link, {
      href: app.route.user(user)
    }, username(user)) : username(user), user && user.isOnline() && userOnline(user))), m("li", {
      className: "item-postMeta"
    }, m("div", {
      className: "PostMeta-wrapper"
    }, m(PostMeta, {
      post: post
    }))), m("li", {
      className: "item-postNumber"
    }, m("div", {
      className: "Post-number"
    }, m("i", {
      className: "fas fa-hashtag"
    }), app.translator.trans('bizkaitarra-lineup.forum.post.reply_number', {
      number: post.number()
    })))), m("ul", {
      className: "PostUser-badges"
    }, user ? listItems(user.badges().toArray()) : [])));
  });
  extend(CommentPost.prototype, 'headerItems', function (items) {
    // Remove core meta as we are adding it inside PostUser now
    items.remove('meta');
  });
  extend(CommentPost.prototype, 'elementAttrs', function (attrs) {
    attrs.className += ' Post--premium';
  });
  override(CommentPost.prototype, 'sideItems', function () {
    return new ItemList();
  });
  extend(CommentPost.prototype, 'view', function (vnode) {
    if (vnode && vnode.children) {
      const findAndAddGrid = nodes => {
        if (!nodes) return;
        const arr = Array.isArray(nodes) ? nodes : [nodes];
        for (const node of arr) {
          if (node && node.attrs && node.attrs.className) {
            if (node.attrs.className.includes('Post-main')) {
              if (!node.attrs.className.includes('Post-gridContainer')) {
                node.attrs.className += ' Post-gridContainer';
              }
              return;
            }
          }
          if (node && node.children) findAndAddGrid(node.children);
        }
      };
      findAndAddGrid(vnode.children);
      if (vnode.children[0] && !vnode.children[1]) {
        const container = vnode.children[0];
        container.attrs = container.attrs || {};
        container.attrs.className = (container.attrs.className || '') + ' Post-gridContainer';
      }
    }

    // Búsqueda profunda para añadir la clase al pie del post (solo si tiene contenido)
    const findAndAddClass = nodes => {
      if (!nodes) return;
      const nodeArray = Array.isArray(nodes) ? nodes : [nodes];
      nodeArray.forEach(node => {
        if (node && node.attrs && node.attrs.className && node.attrs.className.includes('Post-footer')) {
          // Solo añadir si tiene hijos (lo que indica que Flarum ha metido algo)
          const hasContent = node.children && (Array.isArray(node.children) ? node.children.length > 0 : true);
          if (hasContent && !node.attrs.className.includes('Post-footer--premium')) {
            node.attrs.className += ' Post-footer--premium';
          }
        }
        if (node && node.children) findAndAddClass(node.children);
      });
    };
    findAndAddClass(vnode.children);
  });
  extend(CommentPost.prototype, 'actionItems', function (items) {
    initReactionClickBehavior();
    if (items.has('reply')) {
      const replyButton = items.get('reply');
      if (replyButton) {
        replyButton.attrs.onclick = () => {
          var _flarum$reg2, _flarum$reg2$get, _flarum$reg3, _flarum$reg3$get;
          const post = this.attrs.post;
          if (!post) return;
          const reply = (_flarum$reg2 = flarum.reg) == null || (_flarum$reg2$get = _flarum$reg2.get) == null ? void 0 : _flarum$reg2$get.call(_flarum$reg2, 'flarum-mentions', 'forum/utils/reply');
          const getSelectedText = (_flarum$reg3 = flarum.reg) == null || (_flarum$reg3$get = _flarum$reg3.get) == null ? void 0 : _flarum$reg3$get.call(_flarum$reg3, 'flarum-mentions', 'forum/utils/selectedText');

          // 1. Detectar si el usuario ha seleccionado texto específicamente dentro del cuerpo del post
          let quote = '';
          if (getSelectedText) {
            try {
              quote = getSelectedText(this.$('.Post-body')) || '';
            } catch (e) {}
          }
          if (!quote && window.getSelection) {
            var _window$getSelection;
            const sel = (_window$getSelection = window.getSelection()) == null || (_window$getSelection = _window$getSelection.toString()) == null ? void 0 : _window$getSelection.trim();
            if (sel) {
              quote = sel;
            }
          }

          // 2. Si no hay selección manual de texto, citar un extracto breve del post (80 caracteres como en prod)
          if (!quote) {
            const content = post.contentPlain && post.contentPlain() || '';
            const maxLength = 80;
            quote = content.length > maxLength ? content.substring(0, maxLength).trim() + '...' : content;
          }

          // 3. Delegar en la utilidad nativa de flarum-mentions:
          // Gestiona si el usuario está autenticado (o abre LogInModal),
          // abre el composer y espera a composer.editorReady() para evitar fallos a la primera.
          if (reply) {
            reply(post, quote).catch(() => {});
          } else if (app.composer) {
            app.composer.load(ReplyComposer, {
              user: app.session.user,
              discussion: post.discussion()
            });
            app.composer.show();
          }
          return true;
        };
      }
    }
  });
  initReactionClickBehavior();
}
let reactionsInitialized = false;
function initReactionClickBehavior() {
  var _flarum$reg4, _flarum$reg4$get, _window$flarum;
  if (reactionsInitialized) return;
  const $ = window.$ || window.jQuery;

  // Obtener PostReactAction de fof-reactions y gestionar el click para abrir/cerrar el selector
  const PostReactAction = ((_flarum$reg4 = flarum.reg) == null || (_flarum$reg4$get = _flarum$reg4.get) == null ? void 0 : _flarum$reg4$get.call(_flarum$reg4, 'fof-reactions', 'forum/components/PostReactAction')) || ((_window$flarum = window.flarum) == null || (_window$flarum = _window$flarum.extensions) == null || (_window$flarum = _window$flarum['fof-reactions']) == null || (_window$flarum = _window$flarum.components) == null ? void 0 : _window$flarum.PostReactAction);
  if (PostReactAction) {
    reactionsInitialized = true;

    // Desactivar el oncreate de fof-reactions que vincula un listener touchend roto a $('.Reactions')
    // el cual causa que en móviles el menú se abra y cierre instantáneamente en el mismo toque
    override(PostReactAction.prototype, 'oncreate', function () {
      // Neutralizado: fof-reactions ya no interferirá con los toques
    });
    override(PostReactAction.prototype, 'reactButton', function (original) {
      const vnode = original();
      vnode.attrs = vnode.attrs || {};
      vnode.attrs.onclick = e => {
        e.preventDefault();
        e.stopPropagation();
        if (!$) return;
        const $btn = $(e.currentTarget || e.target);
        const $dropdown = $btn.closest('.Reactions--react').find('.CommentPost--Reactions');
        const wasOpen = $dropdown.hasClass('mobile-show') || $dropdown.hasClass('is-open');
        $('.CommentPost--Reactions').removeClass('mobile-show is-open');
        if (!wasOpen) {
          $dropdown.addClass('mobile-show is-open');
        }
      };
      return vnode;
    });
  }
  if (!$) return;

  // 2. Delegación en document como fallback para cuando el botón es clickeado directamente
  $(document).off('.reactionsClick');
  $(document).on('click.reactionsClick', '.Reactions--react .Reactions--ShowReactions', function (e) {
    e.preventDefault();
    e.stopPropagation();
    const $dropdown = $(this).closest('.Reactions--react').find('.CommentPost--Reactions');
    const wasOpen = $dropdown.hasClass('mobile-show') || $dropdown.hasClass('is-open');
    $('.CommentPost--Reactions').removeClass('mobile-show is-open');
    if (!wasOpen) {
      $dropdown.addClass('mobile-show is-open');
    }
  });

  // 3. Cerrar tras seleccionar una reacción del desplegable
  $(document).on('click.reactionsClick', '.CommentPost--Reactions button', function () {
    $('.CommentPost--Reactions').removeClass('mobile-show is-open');
  });

  // 4. Cerrar al hacer click o tap fuera de las reacciones
  $(document).on('click.reactionsClick touchend.reactionsClick', function (e) {
    if (!$(e.target).closest('.Reactions--react').length) {
      $('.CommentPost--Reactions').removeClass('mobile-show is-open');
    }
  });

  // 5. Cerrar con la tecla Escape
  $(document).on('keydown.reactionsClick', function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      $('.CommentPost--Reactions').removeClass('mobile-show is-open');
    }
  });

  // 6. Click en custom-emoji para abrir modal de zoom y copiar para WhatsApp
  $(document).on('click.customEmojiClick', '.custom-emoji', function (e) {
    e.preventDefault();
    e.stopPropagation();
    const $img = $(this);
    const src = $img.attr('src') || '';
    let name = $img.attr('alt') || '';
    // Clean :name: -> name
    name = name.replace(/^:|:$/g, '');
    if (!name && src) {
      const parts = src.split('/');
      name = parts[parts.length - 1].replace(/\.[^/.]+$/, '');
    }
    app.modal.show(CustomEmojiModal, {
      name: name,
      src: src
    });
  });
}